module.exports = __webpack_public_path__ + "static/media/thunderstorm-moon.aa6b5ef2.svg";